export default __webpack_public_path__ + "static/media/signup-mobile-1.dfb524a5.png";